<template>
    <div class="container-fluid">
        <div class="row">
            <heading>{{ $t('additional_services.menuName') }}
                <template v-slot:actions>
                    <button class="btn btn-primary" @click="store">{{ $t('core.actions.save') }}</button>
                </template>
            </heading>
        </div>
        <div class="row">
            <div class="card col-12">
                <div class="card-body">
                    <table class="table">
                        <thead>
                        <tr>
                            <th>{{ $t('additional_services.country') }}</th>
                            <th v-for="level in serviceLevel">{{ level }}</th>
                            <th v-for="level in serviceLevelReturn">{{ level }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(country, countryIndex) in countries">
                            <td>{{ $t('countries.' + country.country_code) }}</td>
                            <td>
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" :id="'B2B' + country.country_code" v-model="country.B2BEnabled"
                                           @change="toggleServiceForCountry(countryIndex, 'B2B')">
                                    <label class="custom-control-label" :for="'B2B' + country.country_code">{{ $t('additional_services.available') }}</label>
                                </div>

                                <hr class="border-primary"/>

                                <div class="custom-control custom-checkbox" v-for="(service, index) in services['B2B']" v-if="country.services !== null && country.services['B2B']">
                                    <input type="checkbox" class="custom-control-input" :id="'B2B' + country.country_code + index" :value="index" v-model="country.services['B2B']">
                                    <label class="custom-control-label" :for="'B2B' + country.country_code + index">{{ service }}</label>
                                </div>
                            </td>
                            <td>
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" :id="'B2CCURB' + country.country_code" v-model="country.B2CCURBEnabled"
                                           @change="toggleServiceForCountry(countryIndex, 'B2CCURB')">
                                    <label class="custom-control-label" :for="'B2CCURB' + country.country_code">{{ $t('additional_services.available') }}</label>
                                </div>

                                <hr class="border-primary"/>


                                <div class="custom-control custom-checkbox" v-for="(service, index) in services['B2CCURB']"
                                     v-if="country.services !== null && country.services['B2CCURB']">
                                    <input type="checkbox" class="custom-control-input" :id="'B2CCURB' + country.country_code + index" :value="index"
                                           v-model="country.services['B2CCURB']">
                                    <label class="custom-control-label" :for="'B2CCURB' + country.country_code + index">{{ service }}</label>
                                </div>
                            </td>
                            <td>
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" :id="'B2CINDOOR' + country.country_code" v-model="country.B2CINDOOREnabled"
                                           @change="toggleServiceForCountry(countryIndex, 'B2CINDOOR')">
                                    <label class="custom-control-label" :for="'B2CINDOOR' + country.country_code">{{ $t('additional_services.available') }}</label>
                                </div>

                                <hr class="border-primary"/>

                                <div class="custom-control custom-checkbox" v-for="(service, index) in services['B2CINDOOR']"
                                     v-if="country.services !== null && country.services['B2CINDOOR']">
                                    <input type="checkbox" class="custom-control-input" :id="'B2CINDOOR' + country.country_code + index" :value="index"
                                           v-model="country.services['B2CINDOOR']">
                                    <label class="custom-control-label" :for="'B2CINDOOR' + country.country_code + index">{{ service }}</label>
                                </div>
                            </td>

<!--              RETURN SERVICES              -->

                            <td>
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" :id="'B2BReturn' + country.country_code" v-model="country.B2BReturnEnabled"
                                           @change="toggleReturnServiceForCountry(countryIndex, 'B2B')">
                                    <label class="custom-control-label" :for="'B2BReturn' + country.country_code">{{ $t('additional_services.available') }}</label>
                                </div>

                                <hr class="border-primary"/>

                                <div class="custom-control custom-checkbox" v-for="(service, index) in services['B2B']" v-if="country.return_services !== null && country.return_services['B2B']">
                                    <input type="checkbox" class="custom-control-input" :id="'B2BReturn' + country.country_code + index" :value="index" v-model="country.return_services['B2B']">
                                    <label class="custom-control-label" :for="'B2BReturn' + country.country_code + index">{{ service }}</label>
                                </div>
                            </td>
                            <td>
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" :id="'B2CCURBReturn' + country.country_code" v-model="country.B2CCURBReturnEnabled"
                                           @change="toggleReturnServiceForCountry(countryIndex, 'B2CCURB')">
                                    <label class="custom-control-label" :for="'B2CCURBReturn' + country.country_code">{{ $t('additional_services.available') }}</label>
                                </div>

                                <hr class="border-primary"/>


                                <div class="custom-control custom-checkbox" v-for="(service, index) in services['B2CCURB']"
                                     v-if="country.return_services !== null && country.return_services['B2CCURB']">
                                    <input type="checkbox" class="custom-control-input" :id="'B2CCURBReturn' + country.country_code + index" :value="index"
                                           v-model="country.return_services['B2CCURB']">
                                    <label class="custom-control-label" :for="'B2CCURBReturn' + country.country_code + index">{{ service }}</label>
                                </div>
                            </td>

                            <td>
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" :id="'B2CINDOORReturn' + country.country_code" v-model="country.B2CINDOORReturnEnabled"
                                           @change="toggleReturnServiceForCountry(countryIndex, 'B2CINDOOR')">
                                    <label class="custom-control-label" :for="'B2CINDOORReturn' + country.country_code">{{ $t('additional_services.available') }}</label>
                                </div>

                                <hr class="border-primary"/>

                                <div class="custom-control custom-checkbox" v-for="(service, index) in services['B2CINDOOR']"
                                     v-if="country.return_services !== null && country.return_services['B2CINDOOR']">
                                    <input type="checkbox" class="custom-control-input" :id="'B2CINDOORReturn' + country.country_code + index" :value="index"
                                           v-model="country.return_services['B2CINDOOR']">
                                    <label class="custom-control-label" :for="'B2CINDOORReturn' + country.country_code + index">{{ service }}</label>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { cloneDeep } from 'lodash'

    export default {
        name: 'ServicesCreadit',
        data: () => {
            return {
                countries: lgt.countries,
                serviceLevel: lgt.serviceLevels,
                serviceLevelReturn: lgt.serviceLevelsReturn,
                services: lgt.services,
            }
        },
        methods: {
            toggleServiceForCountry (country, service) {
                if(this.countries[country].services.length === 0) {
                    this.countries[country].services = {};
                }
                if (typeof this.countries[country].services[service] === 'undefined') {
                    this.countries[country].services[service] = []
                } else {
                    delete this.countries[country].services[service]
                }
            },

            toggleReturnServiceForCountry (country, service) {
                if(this.countries[country].return_services.length === 0) {
                    this.countries[country].return_services = {};
                }
                if (typeof this.countries[country].return_services[service] === 'undefined') {
                    this.countries[country].return_services[service] = []
                } else {
                    delete this.countries[country].return_services[service]
                }
            },
            store () {
                axios.post('/services', this.countries).then((response) => {
                    window.location.href = '/services?success'
                }).catch((err) => {
                    this.errors = err.response.data.errors
                })
            },
        },
    }
</script>
